import * as React from 'react';
import { ColivingSection } from '../components/homepage/ColivingSection';
import { HeroSection } from '../components/homepage/HeroSection';
import { FeaturesSection } from '../components/homepage/FeaturesSection';
import { TestimonialsSection } from '../components/homepage/TestimonialsSection';
import { BlogSection } from '../components/homepage/BlogSection';
import { BottomCTA } from '../components/layout/BottomCTA';

const Homepage = () => (
  <div className="flex flex-col gap-20">
    <HeroSection />
    <FeaturesSection />
    <ColivingSection />
    <TestimonialsSection />
    <BlogSection />
    <BottomCTA />
  </div>
);

export default Homepage;
